
  const appointmentType = {
    path: "/appointmentType",
    name: "appointmentType",
    component: () => import(/* webpackChunkName: "appointment_type" */ "@/components/appointmentType/AppointmentTypeIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "appointment_type" */ "@/components/appointmentType/AppointmentTypeView.vue"), name: "appointmentTypeView" },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "appointment_type" */ "@/components/appointmentType/AppointmentTypeEdit.vue"), name: "appointmentTypeEdit" },
      { path: "create", component: () => import(/* webpackChunkName: "appointment_type" */ "@/components/appointmentType/AppointmentTypeCreate.vue"), name: "appointmentTypeCreate"}
    ],
    meta: { authorize: [], requiresAuth: true }
  };

export default appointmentType;
    